
import { Component, effect, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatButtonModule} from "@angular/material/button";
import {AgentBuilderService} from "../services/agent-builder.service";
import {MatHint} from "@angular/material/form-field";

@Component({
  selector: 'agent-admin-settings',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatHint
],
  templateUrl: './agent-admin-settings.component.html',
  styleUrl: './agent-admin-settings.component.scss'
})
export class AgentAdminSettingsComponent {
  agentForm!: FormGroup;

  #formBuilder = inject(FormBuilder);
  #agentBuilderService = inject(AgentBuilderService);

  constructor() {
    effect(() => {
      if (this.#agentBuilderService.agent()) {
        this.agentForm = this.#formBuilder.group({
          isDisabled: new FormControl(this.#agentBuilderService.agent().isDisabled),
          isUniversal: new FormControl(this.#agentBuilderService.agent().isUniversal)
        });
      }
    });
  }
}
